import { render, staticRenderFns } from "./LxLayout.htm?vue&type=template&id=c676c44a&scoped=true&"
import script from "./LxLayout.ts?vue&type=script&lang=js&"
export * from "./LxLayout.ts?vue&type=script&lang=js&"
import style0 from "./LxLayout.scss?vue&type=style&index=0&id=c676c44a&lang=scss&scoped=true&"
import style1 from "./LxLayoutCommon.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c676c44a",
  null
  
)

export default component.exports